<template>
    <div>
        <router-view />
    </div>
</template>

<script>
import useAnalytics from "@Functions/useAnalytics.js";
export default {
    name: "App",
    setup() {
        const {
            getAnalytics,
            getAdminAnalytics,
            getAnalyticsByTable,
            setupData,
            currentRoute,
            isLoading,
            router,
            store,
        } = useAnalytics();

        router.afterEach(() => {
            callAnalytics();
        });

        const callAnalytics = () => {
            setupData();
            if (!isLoading.value) {
                switch (currentRoute.value.name) {
                case "admin":
                    getAdminAnalytics();
                    break;
                case "permutations":
                    getAnalytics();
                    break;
                case "aggregation-table":
                    getAnalyticsByTable();
                    break;
                case "user-activities":
                    store.dispatch("User/getUsersActivities", {});
                    break;
                }
            }
        };
    },
};
</script>